import { FormControl, FormGroup } from "@angular/forms";

export interface GpsTracking {
    Enable: string;
    Server: string;
    Filter: {
        All: boolean;
        RMC: boolean;
        GGA: boolean;
        GSA: boolean;
        GSV: boolean;
        VTG: boolean;
    };
    Mode: string;
    Port: number;
    Period: number;
    DeviceID: string;
};

export enum RmcOnlyFilter {
    RMC = "RMC",
    ALL = "All"
};

export interface GpsTrackingForm {
    Enable: FormControl<string>;
    Server: FormControl<string>;
    Filter: FormGroup<{
        All: FormControl<boolean>;
        RMC: FormControl<boolean>;
        GGA: FormControl<boolean>;
        GSA: FormControl<boolean>;
        GSV: FormControl<boolean>;
        VTG: FormControl<boolean>;
    }>;
    FilterRmcOnly: FormControl<RmcOnlyFilter>;
    Mode: FormControl<string>;
    Port: FormControl<number>;
    Period: FormControl<number>;
    DeviceID: FormControl<string>;
};